import { useParams } from "@tanstack/react-router";

import { TabListView } from "#components";

export const SettingsRecordList = () => {
	const { entityName } = useParams({ strict: false });

	return (
		<TabListView
			key={entityName}
			entity={entityName}
			basePath={`/settings/${entityName}`}
			paramName="recordID"
			scope={`settings-${entityName}`}
		/>
	);
};
